<template>
  <div>
    <c-title>Konto</c-title>

    <c-form @submit.prevent="submit" >

      <c-grid>

        <c-grid-item
          v-if="!$is(['applicant'])"
          :span="6"
        >
          <c-form-input
            id="first-name"
            :errors="[{
              message: 'Dieses Feld ist erforderlich.',
              show: !$v.firstName.required
            }]"
            :has-error="$v.firstName.$error"
            :is-valid="!$v.firstName.$invalid"
            v-model="firstName"
            aria-required="true"
            autocomplete="given-name"
            label="Vorname *"
            @input="$v.firstName.$touch"
          />
        </c-grid-item>

        <c-grid-item
          v-if="!$is(['applicant'])"
          :span="6"
        >
          <c-form-input
            id="last-name"
            :errors="[{
              message: 'Dieses Feld ist erforderlich.',
              show: !$v.lastName.required
            }]"
            :has-error="$v.lastName.$error"
            :is-valid="!$v.lastName.$invalid"
            v-model="lastName"
            aria-required="true"
            autocomplete="family-name"
            label="Nachname *"
            @input="$v.lastName.$touch"
          />
        </c-grid-item>

        <p>Für die Änderung Ihrer E-Mailadresse, die Löschung einzelner persönlicher Daten sowie zur Löschung Ihres gesamten Accounts wenden Sie sich bitte <a
          href="https://www.claussen-simon-stiftung.de/de/legal/kontakt/"
          target="_blank"
          rel="noopener"
        >direkt an uns</a>.</p>

        <c-form-input
          id="email"
          v-model="email"
          disabled
          label="E-Mail-Adresse"
          type="email"
        />

        <c-form-input
          id="new-password"
          :errors="[{
            message: `Ihr Passwort muss mindestens ${$v.newPassword.$params.minLength.min} Zeichen lang sein.`,
            show: !$v.newPassword.minLength
          }]"
          :has-error="$v.newPassword.$error"
          :is-valid="!$v.newPassword.$invalid"
          v-model="newPassword"
          autocomplete="new-password"
          label="Neues Passwort"
          type="password"
          @input="$v.newPassword.$touch"
        />

        <c-form-input
          v-if="newPassword"
          id="new-password-repeat"
          :errors="[{
            message: 'Dieses Feld ist erforderlich.',
            show: !$v.newPasswordRepeat.required
          }, {
            message: 'Ihre Passwörter müssen übereinstimmen.',
            show: !$v.newPasswordRepeat.sameAsPassword
          }]"
          :has-error="$v.newPasswordRepeat.$error"
          :is-valid="!$v.newPasswordRepeat.$invalid"
          v-model="newPasswordRepeat"
          aria-required="true"
          autocomplete="new-password"
          label="Passwort wiederholen"
          type="password"
          @input="$v.newPasswordRepeat.$touch"
        />

        <c-form-input
          v-if="newPassword"
          id="current-password"
          :errors="[{
            message: 'Dieses Feld ist erforderlich.',
            show: !$v.currentPassword.required
          }]"
          :has-error="$v.currentPassword.$error"
          :is-valid="!$v.currentPassword.$invalid"
          v-model="currentPassword"
          aria-required="true"
          autocomplete="current-password"
          label="Aktuelles Passwort"
          type="password"
          @input="$v.currentPassword.$touch"
        />

      </c-grid>

      <c-button :busy="saveStatus === $config.status.SAVING">
        Speichern
      </c-button>

    </c-form>
  </div>
</template>

<script>
import CButton from '@/components/CButton'
import CForm from '@/components/form/CForm'
import CFormInput from '@/components/form/CFormInput'
import CGrid from '@/components/CGrid'
import CGridItem from '@/components/CGridItem'
import CTitle from '@/components/CTitle'

import { minLength, required, requiredIf, sameAs } from 'vuelidate/lib/validators'
import handleRequestError from '@/functions/handleRequestError'

export default {
  name: 'VDashboardAccount',

  components: {
    CButton,
    CForm,
    CFormInput,
    CGrid,
    CGridItem,
    CTitle
  },

  data () {
    return {
      saveStatus: this.$config.status.IDLE,
      email: this.$store.state.user.data.email,
      firstName: this.$store.state.user.data.first_name,
      lastName: this.$store.state.user.data.last_name,
      currentPassword: '',
      newPassword: '',
      newPasswordRepeat: ''
    }
  },

  validations () {
    const schema = {
      newPassword: {
        minLength: minLength(5)
      },
      newPasswordRepeat: {
        sameAsPassword: sameAs('newPassword'),
        requiredIf: requiredIf('newPassword')
      },
      currentPassword: {
        requiredIf: requiredIf('newPassword')
      }
    }

    if (!this.$is(['applicant'])) {
      schema.firstName = {
        required
      }

      schema.lastName = {
        required
      }
    }

    return schema
  },

  methods: {
    submit () {
      this.$v.$touch()

      if (this.$v.$invalid) {
        this.$store.commit('notifications/add', {
          type: 'error',
          text: 'Bitte füllen Sie alle Felder korrekt aus.'
        })

        return
      }

      this.saveStatus = this.$config.status.SAVING

      this.$api.patch('user/change-account/', {
        first_name: this.firstName,
        last_name: this.lastName,
        new_password: this.newPassword,
        new_password_repeat: this.newPasswordRepeat,
        current_password: this.currentPassword
      })
        .then(() => {
          return this.$api.get('auth/user/')
        })
        .then(response => {
          this.$store.commit('user/data', response.data)
          this.$store.commit('notifications/add', {
            text: 'Ihre Kontoeinstellungen wurden aktualisiert.',
            type: 'success'
          })
          this.$router.push({ name: 'dashboard' })
        })
        .catch(error => {
          handleRequestError({
            error,
            fallback: 'Ihre Kontoinformationen können zurzeit leider nicht gespeichert werden. Bitte versuchen Sie es später erneut.'
          })

          this.saveStatus = this.$config.status.ERROR
        })
    }
  }
}
</script>
